import React from 'react';
import BackButtonPage from '../../../../components/BackButtonPage';
import "../../../../styles/TerSegedlet.css"
import { Link } from 'react-router-dom';


function TerSegedlet() {
  return (
    <div className='page-content-container'>
      <p>
        Jelen áttekintés és gyűjtemény aktualitását,  az  összeállításának  időpontjában  éppen 
        közelgő, Mohács-500 emlékévre való felkészülés adta. A konkrét feladat az 1526-ban, 
        Buda alól a mohácsi csatamezőre vonuló magyar királyi had Dunai flottájának, ismeretterjesztő 
        értékkel bíró megjelenítését segítő háttéranyag összeállítása volt.
        Történelmi életmód rekonstrukciós (reenactment) módszerekkel szeretnénk újraalkotni 
        és a gyakorlatban szemléltetni a hajóhad egy (vagy több)  naszádját  és  megjeleníteni
        ezen naszádok hajóskatonáit.
      </p>
      <p>
        Fontos szempont, hogy mind a hajó, annak teljes felszerelésével egyetemben, mind pedig 
        a legénység viselete, eszköztára, fegyverei, kiegészítő tárgyai a lehetőségek  szerinti  legautentikusabbak,
         egyúttal a gyakorlatban vizsgálható módon, az egykori rendeltetésüknek
        megfelelő használatra alkalmasak legyenek.  Ennek  gyakorlati  tesztje  egy  kilencnapos 
        evezőstúra, ahol a naszád a 18-20 fős legénységével Buda alól lehajózik Mohácsra. 
        A projektben résztvevő csoport a kikötések alkalmával  korhű  haditábort  alakít  ki  és 
        szemlélteti mindazt, ami a megjelenített történelmi szituáció keretein belül ma bemutatható.
        A nehézséget a tematika összetettsége és a műfaj sajátosságaiból adódó tényezők jelentik. 
        Ilyenek például a relatív forrásszegénység a konkrét szituáció és a karakterek vonatkozásában, 
        valamint a majdani megvalósíthatóság/megjelenítés előzetesen még bizonytalan 
        elemei. Komoly támpontokat adnak és segítséget jelentenek viszont a korábbi hasonló 
        projektek gyakorlatai, az interdiszciplináris kutatások eredményei, és a műfaj három 
        évtizednyi hazai jelenlétének tapasztalatai. 
      </p>
      <div className='zold-kiemeles-container'>
        <Link to="/attekintes-a-korszakrol" className="zold-kiemeles">
            •	Áttekintés a korszakról, az akkoriban királynaszádosoknak nevezett Dunai hajóskatonák világáról
        </Link>
      </div>
      <p>
        A forrásmunkák örvendetesen és dinamikusan bővülő köre:
      </p>
      <div className='zold-kiemeles-container'>
        <Link to="/tanulmanyok" className="zold-kiemeles">
          •	Az adott történelmi pillanatot feldolgozó, általunk ismert és elérhető tanulmányok
        </Link>
      </div>
      <div className='zold-kiemeles-container'>
        <Link to="/projekt-tampontok" className="zold-kiemeles">
          •	A projekthez támpontokat adó, egykorú (vagy közel egykorú...) ábrázolások 
        </Link>
      </div>
      <div className='zold-kiemeles-container' style={{ marginBottom: "calc(5px + 2vh)" }}>
        <Link to="/targyi-leletek" className="zold-kiemeles">
          •  Tárgyi leletek a Mohácsi csata történelmi időszakából
        </Link>
      </div>
      <BackButtonPage to="/projekt" />
    </div>
  );
}

export default TerSegedlet;
